module.exports = __webpack_public_path__ + "static/completeEN-aba66f58facfb64e3601f7a2c5e84651.png";